var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "formRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "px-3 pt-3" }, [
        _c("div", { staticClass: "d-flex align-items-center mb-3 pt-2" }, [
          _c("img", {
            staticClass: "mr-2",
            staticStyle: { width: "20px", height: "20px" },
            attrs: {
              alt: "",
              src: require("@/assets/img/file-plus-circle.svg")
            }
          }),
          _c("span", { staticClass: "color-black font-18 font-weight-bold" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.isEditMode
                    ? "Editar Voucher de Pago"
                    : "Añadir Voucher de Pago"
                ) +
                " "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-4" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            id: "voucherNumber",
                            "custom-error-msg": "El campo es requerido",
                            error: errors[0],
                            label: "Número de Voucher:",
                            placeholder: "Ingrese número de voucher"
                          },
                          model: {
                            value: _vm.form.voucherNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "voucherNumber", $$v)
                            },
                            expression: "form.voucherNumber"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-4 mt-3 mt-md-0" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-date-picker", {
                          attrs: {
                            id: "voucherDate",
                            "class-container": "w-100",
                            "custom-error-msg": "El campo es requerido",
                            error: errors[0],
                            label: "Fecha de Voucher:",
                            placeholder: "DD/MM/YYYY"
                          },
                          model: {
                            value: _vm.form.voucherDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "voucherDate", $$v)
                            },
                            expression: "form.voucherDate"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3 pb-3" }, [
          _c(
            "div",
            { staticClass: "col-12 d-flex justify-content-end" },
            [
              _c(
                "action-button",
                {
                  attrs: {
                    i: "fas fa-times-circle",
                    variant: "outline-danger px-3 mr-2"
                  },
                  on: { click: _vm.onCancel }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "action-button",
                {
                  attrs: { i: "fas fa-save", variant: "success px-3" },
                  on: { click: _vm.onSave }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }